import {
  CURRENCY_COOKIE_MAX_AGE_SECONDS,
  CURRENCY_COOKIE_NAME,
  DEFAULT_CURRENCY,
  parseCustomerCurrency,
  type CustomerCurrency,
} from '@/config/currency';

export function readBrowserCurrencyCookie(): CustomerCurrency {
  if (typeof document === 'undefined') {
    return DEFAULT_CURRENCY;
  }

  const prefix = `${CURRENCY_COOKIE_NAME}=`;
  const match = document.cookie.split('; ').find((row) => row.startsWith(prefix));
  return parseCustomerCurrency(match ? match.slice(prefix.length) : undefined);
}

export function writeBrowserCurrencyCookie(currency: CustomerCurrency): void {
  if (typeof document === 'undefined') {
    return;
  }

  document.cookie = [
    `${CURRENCY_COOKIE_NAME}=${currency}`,
    'path=/',
    `max-age=${CURRENCY_COOKIE_MAX_AGE_SECONDS}`,
    'SameSite=Lax',
  ].join('; ');
}
